import React, { useState } from 'react';
import { generateGapFormula } from '../../utils/gapFormulaGenerator';

function renderWithRedBrackets(text) {
  const parts = text.split(/(\[[^\]]+\])/g);
  return parts.map((part, i) => {
    if (/^\[.+\]$/.test(part)) {
      return (
        <span key={i} style={{ color: '#dc2626', fontWeight: 600 }}>
          {part}
        </span>
      );
    }
    return part;
  });
}

export default function Step6_GapFormula({ context, topGap, formulaData, onChange, onNext, onBack }) {
  const [copied, setCopied] = useState(false);

  const autoFormula = generateGapFormula({
    topGapType: topGap?.type,
    keywords: context.keywords?.filter((k) => k.trim()) || [],
    topic: context.topic || '',
    discipline: context.discipline || '',
    academicLevel: context.academicLevel || 'Masters',
  });

  const currentFormula = formulaData || autoFormula;

  const handleCopy = () => {
    navigator.clipboard.writeText(currentFormula).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="gf-step">
      <div className="gf-step-header">
        <span className="gf-step-badge">Phase 6</span>
        <h2>Gap Formula Generator</h2>
        <p>
          Based on your detected gap, the engine has auto-generated a Gap Formula statement
          using the template: <em>"Although prior studies have examined X, little attention has
          been given to Y in Z…"</em> Edit as needed.
        </p>
      </div>

      <div className="gf-formula-box">
        <div className="gf-formula-label">
          <strong>📝 Auto-Generated Gap Formula</strong>
          <button className="gf-btn-icon" onClick={handleCopy} title="Copy to clipboard">
            {copied ? '✅ Copied!' : '📋 Copy'}
          </button>
        </div>

        <div className="gf-formula-preview">
          {renderWithRedBrackets(currentFormula)}
        </div>

        <p className="gf-hint" style={{ marginTop: '0.5rem' }}>
          Items in <span style={{ color: '#dc2626', fontWeight: 600 }}>red brackets</span> need your attention. Edit the text below to replace them.
        </p>

        <textarea
          className="gf-formula-textarea"
          rows={6}
          value={currentFormula}
          onChange={(e) => onChange(e.target.value)}
        />
        <p className="gf-hint">
          Tip: Replace <em>[your specific contribution]</em> with your actual research focus,
          and update the <em>[field]</em> brackets to your specific discipline if needed.
        </p>
      </div>

      <div className="gf-formula-guide">
        <h4>Template Structure</h4>
        <div className="gf-template-parts">
          <div className="gf-template-part gf-tp-x">
            <strong>X — Prior Knowledge</strong>
            <p>What has already been studied (based on your reviewed abstracts)</p>
          </div>
          <div className="gf-template-arrow">→</div>
          <div className="gf-template-part gf-tp-y">
            <strong>Y — The Gap</strong>
            <p>What has NOT been adequately addressed (your detected gap type)</p>
          </div>
          <div className="gf-template-arrow">→</div>
          <div className="gf-template-part gf-tp-z">
            <strong>Z — The Context</strong>
            <p>The specific discipline, population, or setting you will study</p>
          </div>
        </div>
      </div>

      <div className="gf-nav">
        <button className="gf-btn gf-btn-secondary" onClick={onBack}>← Back</button>
        <button className="gf-btn gf-btn-primary" onClick={onNext}>
          Generate Full Gap Report →
        </button>
      </div>
    </div>
  );
}
